<template>
	<div class="long_row">

		<div class="row">
			<div class="col-12">
				<div class="sec_tp_msg ace_sec">
					<span>{{exploreCareerText}}</span>
				</div>
			</div>
		</div>

    <div class="row mt-4">
      <div class="col-12">
        <div class="row">
          <div v-for="(career, i) in exploreCareers" class="col-3 explore_intro">
            <div class="pkg_entity_bx programs">
              <button @click.stop="goToCareerDetail(career)" class="ace_sec" :aria-label="'career ' + career.name" tabindex="0">
                <span class="bx_inner">
                  <span :class="{'thumbnail_container': !career.thumbnailURI, 'career-thumbnail': career.thumbnailURI}">
                    <div class="thumbnail_img" v-if="career.thumbnailURI" :class="setImageBgColor(career.thumbnailURI)">
                      <img v-bind:src="career.thumbnailURI" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
                    </div>
										<div v-else class="default_thumbnail career">
                    	<div class="ico-career ic"></div>
										</div>
                  </span>
                  <span class="entity_title" :id="'careerTitle_' + i">
                    <v-clamp class="entity_title_txt" autoresize :max-lines="2">{{ career.name }}</v-clamp>
                  </span>

									<b-popover :target="'careerTitle_' + i" triggers="hover" placement="top" class="title_popup" :container="'entityNameContainer_' + i">
										<div class="title_container">
											{{ career.name }}
										</div>
									</b-popover>
									<div :id="'entityNameContainer_' + i" class="title_container_popup"></div>
                </span>
              </button>
            </div>
          </div>
          <div class="col-3 explore_intro explore_more">
            <div class="pkg_entity_bx programs">
              <button @click="exploreCareersClicked" class="ace_sec">
                <span class="bx_inner">
                  <span class="thumbnail_container">
                    <div class="ico-career ic"></div>
                  </span>
                  <span class="entity_title career-title">
                    <span class="entity_title_txt">Explore<br />Careers</span>
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2 sec_msg" v-if="isExploreProgramEnabled()">
      <div class="col-12 ace_sec">
        <span>You can also <a href="javascript://" style="color: #157099;" @click="exploreProgramsClicked">explore all available programs.</a></span>
      </div>
    </div>
	</div>
</template>

<script>
	import { mapActions, mapState } from 'vuex'
	import { StorageFactory } from '../../../storageFactory'
  import { PACKAGE } from '../../../package_constants'
	import VClamp from 'vue-clamp'

  export const localStore = StorageFactory(() => localStorage)

	export default {
		name: 'learner-explore-careers',
		components: {
      VClamp
    },
		data: () => {
			return {
        exploreCareers: [],
				exploreCareerText: 'Check out some of these careers'
			}
		},
    created () {
      this.populateLearnerDashboradCareers()
    },
    beforeMount () {
      this.$root.$on('reloadLearnerDashboard', () => {
        this.populateLearnerDashboradCareers()
      })
    },
		methods: {
			...mapActions([
	      'loadLearnerExploreCareers'
	    ]),
      populateLearnerDashboradCareers () {
        this.loadLearnerExploreCareers().then(resp => {
          this.exploreCareers = resp
        })
      },
      exploreCareersClicked () {
        return this.$router.push({name: 'exploreCareerResults'})
      },
      exploreProgramsClicked () {
        return this.$router.push({name: 'exploreProgramGuideResults'})
      },
      setImageBgColor (imageURL) {
        let getImageURL = imageURL.split('/')
        let getImageName = getImageURL[getImageURL.length - 1].match(/(.*)\.[\w]+$/)[1]
        return getImageName.replace(/\./g, '__')
      },
      isExploreProgramEnabled () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
      if (exploreFeature && exploreFeature.enabled) {
        return true
      }
      return false
      },
      goToCareerDetail (career) {
        let routerParams = {
	        code: career.pragyaSoc,
	        returnTo: 'learnerDashboard',
	        showBackToResultButton: true
	      }
        return this.$router.push({name: 'careerDetail', params: routerParams, query: {returnTo: 'learnerDashboard'}})
      }
		},
    computed: {
    ...mapState({
      'enabledFeatures': state => state.institution.enabledFeatures,
    })
    }
	}
</script>

<style scoped>
  .career-thumbnail {
    padding-top: 0px;
  }

  .career-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 18px !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerExploreCareers.vue